/* eslint-disable max-classes-per-file */
type ExceptionCode = 'NotConfirmed' | 'InvalidCredentials' | 'InvalidCode' | 'EmailAlreadyExists' | 'LimitExceeded';

export class AuthException<Code extends ExceptionCode = ExceptionCode> extends Error {
  constructor(
    public readonly code: Code,
    public readonly message: string,
  ) {
    super(message);
  }
}
